// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1royt","Default":"Button_Default__2Es2N","Success":"Button_Success__3nIjt","Danger":"Button_Danger__28NzM"};